"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCustomV2 = exports.serializeCustomV2 = void 0;
const serializeCustomV2 = (item) => {
    return typeof item.data.stringValue === "string" ? item.data.stringValue : "";
};
exports.serializeCustomV2 = serializeCustomV2;
const validateCustomV2 = (item) => {
    const hasData = Object.values(item.data || {}).filter(Boolean).length > 0;
    if (!item.required || hasData) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must be filled out." } };
};
exports.validateCustomV2 = validateCustomV2;
//# sourceMappingURL=customV2.js.map